module.exports = __webpack_public_path__ + "static/insects-and-fungi-icon-70px-00fddfed9bbdcf9af2c877bf1a968505.svg";